import { render, staticRenderFns } from "./ItemMapper.vue?vue&type=template&id=d4c4c070&scoped=true&"
import script from "./ItemMapper.vue?vue&type=script&lang=js&"
export * from "./ItemMapper.vue?vue&type=script&lang=js&"
import style0 from "./ItemMapper.vue?vue&type=style&index=0&id=d4c4c070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c4c070",
  null
  
)

export default component.exports